import UserApi from '../../../api/UserApi';
import AdminAPI from '../../../api/AdminApi';

import * as TYPES from './TYPES';

export const getSeletedType = state => state.userManagement.searchBar.selected;
export const getActionType = state =>
  state.userManagement.searchBar.selectedAction;

export const getUsers = state => state.userManagement.users;

export const getResult = state => state.userManagement.users.success;
export const getSelectedUser = state => state.userManagement.users.selectedUser;
export const getRoles = state => state.userManagement.users.roles;
export const getEntities = state => state.userManagement.users.entities;
export const getRestrictions = state => state.userManagement.users.restrictions;
export const getTimeZones = state => state.userManagement.users.timeZones;

export const getInputText = state => state.userManagement.searchBar.input;
// Global search - search text changed
export const onInput = params => (dispatch, getState) => {
  dispatch({
    type: TYPES.INPUT_TEXT_CHANGE,
    payload: {
      input: params.inputText || params
    }
  });
};

// Global search - search type changed reset input text
export const onSelect = params => ({
  type: TYPES.SELECT_TYPE_CHANGE,
  payload: { selected: params.value, input: '' }
});

export const onActionSelect = params => ({
  type: TYPES.SELECT_ACTIONTYPE_CHANGE,
  payload: { selectedAction: params.value }
});

export const fetchRoles = () => (dispatch, getState) => {
  const roles = getRoles(getState());
  if (roles && roles.length) {
    return dispatch({
      type: `${TYPES.GET_ROLES}_FULFILLED`,
      payload: roles
    });
  }
  return dispatch({
    type: TYPES.GET_ROLES,
    payload: UserApi.getRoles()
      .then(data => data)
      .catch(e => console.log(e))
  });
};

export const fetchTimezones = () => (dispatch, getState) => {
  const state = getState();
  const { countryCode } = state.userManagement.users.selectedUser;
  return dispatch({
    type: TYPES.GET_TIMEZONES,
    payload: UserApi.getTimeZones(countryCode)
      .then(data => data)
      .catch(err => err)
  });
};
export const fetchEntities = () => ({
  type: TYPES.GET_ENTITIES,
  payload: UserApi.getBusinessEntities()
    .then(data => data)
    .catch(e => console.log(e))
});

export const getUserRestriction = userId => ({
  type: TYPES.GET_USER_RESTRICTIONS,
  payload: AdminAPI.getUserRestrictions(userId)
    .then(data => data)
    .catch(e => console.log(e))
});

export const fetchUser = userId => dispatch => {
  dispatch(fetchRoles());
  dispatch(fetchEntities());
  setTimeout(() => {
    dispatch(fetchTimezones());
  }, 5000);
  dispatch({
    type: TYPES.GET_USER,
    payload: AdminAPI.getUser(userId)
      .then(data => {
        dispatch(getUserRestriction(data.userId));
        return data;
      })
      .catch(err => err)
  });
};
export const selectUser = user => dispatch => {
  fetchUser(user.userId);
  dispatch(fetchRoles());
  dispatch(fetchEntities());
  dispatch(getUserRestriction(user.userId));
  setTimeout(() => {
    dispatch(fetchTimezones());
  }, 5000);
};

export const retriveUsers = searchObj => dispatch => {
  dispatch({
    type: TYPES.GET_USERS,
    payload: UserApi.searchUsers(searchObj.fetchParams)
      .then(data => ({
        ...data,
        ...{ currentPage: searchObj.currentPage }
      }))
      .catch(err => err)
  });
};

export const updateUser = modifiedUser => dispatch => {
  dispatch({
    type: TYPES.UPDATE_USER_FIELD,
    payload: UserApi.updateUser(modifiedUser)
  });
};

export const closeMessage = () => dispatch => {
  dispatch({
    type: 'CLOSEMESSAGE'
  });
};

/** Set Password * */
export const setPassword = newPassword => (dispatch, getState) => {
  const { userId } = getSelectedUser(getState());
  dispatch({
    type: 'SET_PASSWORD',
    payload: AdminAPI.setPassword(userId, newPassword)
  });
};



// WEBPACK FOOTER //
// ./src/features/userManagement/store/action.js